/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let domConfig;
module.exports = {
  get() {
    if (this.updatedFinchSettings) {
      this.updatedFinchSettings = false;
    } else if (domConfig && Object.keys(domConfig).length) {
      return domConfig;
    }

    domConfig =
      Groupon.Utils != null ? Groupon.Utils.getConfigFromDom() : undefined;
    return domConfig;
  },
};
